import type { GetMeResponse, GetPatientSubscriptionResponse } from '@snootsvet/shared/portal'

import { useGetMe } from '@/customer/hooks/use-get-me'
import { useGetPetSubscription } from '@/customer/hooks/use-get-pet-subscription'

export interface PetWithSubscription {
  pet: GetMeResponse['patients'][number] | undefined
  membership: GetPatientSubscriptionResponse | undefined
  isPending: boolean
}

/**
 * Single-pet counterpart to `usePetsWithSubscriptions`. Joins a pet
 * from the `/me` snapshot with its live subscription query.
 */
export function usePetWithSubscription(petId: string): PetWithSubscription {
  const me = useGetMe()
  const subscription = useGetPetSubscription(petId)

  return {
    pet: me.data?.patients.find((p) => p.id === petId),
    membership: subscription.data ?? undefined,
    isPending: me.isPending || subscription.isPending,
  }
}
